import LinkedButton from './LinkedButton';

export default LinkedButton;
